const apiUrl = process.env.REACT_APP_API_URL;

export const GenerateJunit = async (idPrac: string, instructions: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${idPrac}/generate-junit`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ prompt: instructions })
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.log('Error:', error);
        throw error;
    }
};
